// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"8773fb01","787":"56137356"}[chunkId] + ".chunk.css";
};